
/**
 * author:陈冠赤
 */
import http from '../../utils/fetch';
export default {
    baseUrl:"/api/swyl/v1/basic/bscUserInfo",
    updateFile(query) {
        return http({
            url: this.baseUrl+'/',
            method: 'post',
            params: query
        });
    },
    updateData(entity) {
        return http({
            url: this.baseUrl+'/updateByIdChi',
            method: 'post',
            params: entity
        });
    },

    check(companyCode) {
        return http({
            url: this.baseUrl+'/checkCompanyCode',
            method: 'post',
            params: {companyCode}
        });
    },
}
